module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "content-a",
    attrs: {
      "id": "_idParaDest-2",
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/97816425039445#_idTextAnchor055"
    }
  }, [_vm._v("A Letter to Readers")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/97816425039447#_idTextAnchor056"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/97816425039447#_idTextAnchor056"
    }
  }, [_vm._v("Adventure")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/97816425039449#_idTextAnchor058",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/97816425039449#_idTextAnchor058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aging")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394411#_idTextAnchor059",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394411#_idTextAnchor059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Attitude")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394414#_idTextAnchor061",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394414#_idTextAnchor061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Belief")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394415#_idTextAnchor062",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394415#_idTextAnchor062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Challenges")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394417#_idTextAnchor066",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394417#_idTextAnchor066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Change")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394419#_idTextAnchor067",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394419#_idTextAnchor067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Children")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394421#_idTextAnchor072",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394421#_idTextAnchor072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choices")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394423#_idTextAnchor074",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394423#_idTextAnchor074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Comfort")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394425#_idTextAnchor075",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394425#_idTextAnchor075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Community")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394427#_idTextAnchor077",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394427#_idTextAnchor077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Compassion")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394429#_idTextAnchor078",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394429#_idTextAnchor078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Courage")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394431#_idTextAnchor079",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394431#_idTextAnchor079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creativity")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394433#_idTextAnchor084",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394433#_idTextAnchor084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dreams")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394435#_idTextAnchor094",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394435#_idTextAnchor094",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faith")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394437#_idTextAnchor097",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394437#_idTextAnchor097",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Family")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394439#_idTextAnchor098",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394439#_idTextAnchor098",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fatherhood")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor017"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394441#_idTextAnchor099",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394441#_idTextAnchor099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forgiveness")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor018"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394443#_idTextAnchor100",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394443#_idTextAnchor100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friendship")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor019"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394445#_idTextAnchor102",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394445#_idTextAnchor102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gratitude")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor020"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394447#_idTextAnchor104",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394447#_idTextAnchor104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grieving")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor021"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394449#_idTextAnchor106",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394449#_idTextAnchor106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Growth")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor022"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394451#_idTextAnchor107",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394451#_idTextAnchor107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Happiness")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor023"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394453#_idTextAnchor110",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394453#_idTextAnchor110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Health")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor024"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394455#_idTextAnchor111",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394455#_idTextAnchor111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hope")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor025"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394457#_idTextAnchor113",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394457#_idTextAnchor113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Individuality")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor026"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394459#_idTextAnchor116",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394459#_idTextAnchor116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inspiration")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor027"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394461#_idTextAnchor118",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394461#_idTextAnchor118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Integrity")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor028"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394463#_idTextAnchor119",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394463#_idTextAnchor119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joy")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor029"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394465#_idTextAnchor121",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394465#_idTextAnchor121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kindness")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor030"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394467#_idTextAnchor123",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394467#_idTextAnchor123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leadership")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor031"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394469#_idTextAnchor124",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394469#_idTextAnchor124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor032"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394471#_idTextAnchor129",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394471#_idTextAnchor129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor033"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394473#_idTextAnchor132",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394473#_idTextAnchor132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mindfulness")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor034"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394475#_idTextAnchor134",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394475#_idTextAnchor134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Motherhood")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor035"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394477#_idTextAnchor136",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394477#_idTextAnchor136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Passion")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor036"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394479#_idTextAnchor141",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394479#_idTextAnchor141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peace")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor037"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394481#_idTextAnchor143",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394481#_idTextAnchor143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Perseverance")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor038"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394483#_idTextAnchor147",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394483#_idTextAnchor147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Perspective")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor039"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394485#_idTextAnchor150",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394485#_idTextAnchor150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pets")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor040"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394487#_idTextAnchor153",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394487#_idTextAnchor153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Positivity")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor041"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394489#_idTextAnchor154",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394489#_idTextAnchor154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Purpose")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor042"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394491#_idTextAnchor156",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394491#_idTextAnchor156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reflections")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor043"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394493#_idTextAnchor159",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394493#_idTextAnchor159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Renewal")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor044"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394495#_idTextAnchor162",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394495#_idTextAnchor162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Serenity")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor045"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394497#_idTextAnchor165",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394497#_idTextAnchor165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Service")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor046"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/978164250394499#_idTextAnchor166",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/978164250394499#_idTextAnchor166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simplicity")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor047"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/9781642503944101#_idTextAnchor170",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/9781642503944101#_idTextAnchor170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Social Justice")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor048"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/9781642503944103#_idTextAnchor173",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/9781642503944103#_idTextAnchor173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spirituality")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor049"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/9781642503944105#_idTextAnchor176",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/9781642503944105#_idTextAnchor176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Success")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor050"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/9781642503944107#_idTextAnchor178",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/9781642503944107#_idTextAnchor178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Travel")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor051"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/9781642503944109#_idTextAnchor179",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/9781642503944109#_idTextAnchor179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisdom")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor052"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/9781642503944111#_idTextAnchor180",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/9781642503944111#_idTextAnchor180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Affirmations for"), _c('br'), _vm._v("Living")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor053"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/9781642503944113#_idTextAnchor184",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/9781642503944113#_idTextAnchor184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor054"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d35f632","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/97816425039443.vue
// module id = 69
// module chunks = 0